import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';


const useOnNavigation = (callback) => {
  const location = useLocation()
  const { pathname } = location
  const lastPathname = useRef(pathname)

  useEffect(() => {
    if (pathname) {
      callback(location, lastPathname.current)
      lastPathname.current = location?.pathname
    }
  }, [pathname])

  return null
}

export { useOnNavigation }
